import React from 'react';
import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';
// import headerBackground from 'assets/images/backgrounds/bg_header.jpg';

const SectionWrapper = styled('div')(({ theme }) => ({
	// backgroundImage: `url(${headerBackground})`,
	backgroundColor: theme.palette.secondary.mainGray,
	backgroundSize: '100% 600px',
	backgroundAttachment: 'fixed',
	backgroundRepeat: 'no-repeat',
	textAlign: 'center',
	paddingTop: 30,
	[theme.breakpoints.down('md')]: {
		paddingTop: 0
	}
}));

const StaticSectionWrapper = ({ children }) => {
	return (
		<SectionWrapper>
			<Container>{children}</Container>
		</SectionWrapper>
	);
};

export default StaticSectionWrapper;
